module.exports = "/_next/static/images/3-48495aacabea74c1cdb42355661d0f7b.png";